import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';
import { Country } from './country.js';

export class County extends DataModel {
  static readonly TYPE_ID: string = '79db634c1f3d4a4b96961756958c19be';

  constructor(
    public readonly uniqueId: string,
    public readonly name: string,
    public readonly country: Country,
  ) {
    super();
  }

  get $typeId(): string {
    return County.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): County {
    return new County(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'name'),
        toEnumFromString(MapUtils.get<string>(map, 'country'), Country),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'name': this.name,
      'country': fromEnumAsString(this.country),
    };
  }

  clone(): this {
    return new County(
        this.uniqueId,
        this.name,
        this.country,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.name === this.name &&
        other.country === this.country;
  }
}

export class CountyBuilder extends DataModelBuilder<County> {
  build(context: SerializationContext, map: SerializedData): County {
    return County.fromMap(context, map);
  }
}
